<template>
   <figure
      v-if="image"
      :class="[fit]"
      ref="el"
   >
      <img
         v-if="lazy"
         v-lazyload
         ref="imageEl"
         loading="lazy"
         class="lazy"
         :class="[fit]"
         :src="image.src"
         :data-srcset="image.srcset"
         :fit="fit"
         :alt="altText"
         :sizes="`(max-width: 600px) 80vw, 50vw`"
      />
      <img
         v-else
         :src="image.src"
         :srcset="srcset"
         :alt="altText"
         :data-ratio="imgRatio"
         :sizes="`100vw`"
      />
      <slot></slot>
   </figure>
</template>
<script setup lang="ts">
import { lazyload as vLazyload } from "~/directives/lazyload";

const props = defineProps({
   image: {
      default: null,
      type: Object,
   },
   preload: {
      default: false,
      type: Boolean,
   },

   lazy: {
      default: true,
      type: Boolean,
   },
   altText: {
      default: null,
      type: String,
   },

   fit: {
      type: String,
      default: "contain",
      validator(value, props) {
         return ["contain", "cover"].includes(value);
      },
   },
});
const emit = defineEmits(["loaded", "click"]);
const el = ref(null);
const imageEl = ref(null);
const loading = ref(true);

const emitLoaded = () => {
   loading.value = false;
   emit("loaded", true);
};

if (!props.lazy) {
   loading.value = false;
}

if (props.preload) {
   useHead({
      link: [
         {
            rel: "preload",
            as: "image",
            href: props.src,
            imagesrcset: props.image.srcset,
            imagesizes: `100vw`,
         },
      ],
   });
}
onMounted(() => {});
defineExpose({ emitLoaded });
</script>
